import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/secret.vue';
import SecretI18N from '../views/secret-i18n.vue';
import Service from '../views/service.vue';
import ServiceI18N from '../views/service-i18n.vue';
import Login from '../views/sso/login.vue'

Vue.use(VueRouter);

const routes = [
  {
    // 当 /user/:id/profile 匹配成功，
    // UserProfile 会被渲染在 User 的 <router-view> 中
    path: '/draft/account/agreement/data/secret',
    // 2022-09-02 结论，跨境和非跨境用同一个协议页面，由 draft 平台维护
    component: SecretI18N,
  },
  {
    // 当 /user/:id/profile 匹配成功，
    // UserProfile 会被渲染在 User 的 <router-view> 中
    path: '/draft/account/agreement/data/secret-i18n',
    component: SecretI18N,
  },
  {
    // 当 /user/:id/posts 匹配成功
    // UserPosts 会被渲染在 User 的 <router-view> 中
    path: '/draft/account/agreement/data/service',
    component: Service,
  },
  {
    // 当 /user/:id/posts 匹配成功
    // UserPosts 会被渲染在 User 的 <router-view> 中
    path: '/draft/account/agreement/data/service-i18n',
    component: ServiceI18N,
  },
  {
    // 当 /user/:id/posts 匹配成功
    // UserPosts 会被渲染在 User 的 <router-view> 中
    path: '/sso/login/fxg',
    component: Login,
  },
  {
    // 当 /user/:id/posts 匹配成功
    // UserPosts 会被渲染在 User 的 <router-view> 中
    path: '/sso/login/buyin',
    component: Login,
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
  // base: '/draft/account/agreement/data/',
});

export default router;
